import React, { Component } from 'react';
import './Dashboard.css'
import Ripples from 'react-ripples'
// import history from "../historyone";
import {
    BrowserRouter as
        Router,
    Link,
    Redirect, useHistory
} from "react-router-dom";
import AppBar from './AppBar';
import DashboardMap from './DashboardMap'
import DashboardButton1 from './DashboardButton1'
import DashboardButton2 from './DashboardButton2'
 

export class Dashboard extends Component {

    constructor(props) {
        super(props)
        this.state = {
          admin_email:'admin@gmail.com'
        }
    };

    render() {
        // console.log("Values = ", this.state.zones);

        return (
            <div className={'dashboardMainDiv'}>

                <div className={'dashboardHeaderAppBarDiv'}>
                    <AppBar message="DASHBOARD" email={this.state.admin_email}/>
                </div>

                <div className={'dashboardFooterDiv'}>

                    <div className={'dashboardMapDiv'}>

                        <DashboardMap/>

                    </div>

                    <div className={'dashboardBoxesDiv'}>

                        <div className={'dashboardBoxesTopDiv'}>
                            <DashboardButton1/>
                        </div>

                        <div className={'dashboardBoxesBottomDiv'}>
                            <DashboardButton2/>
                        </div>

                    </div>

                </div>

            </div>

        );
    }
}


export default Dashboard
// export default GoogleApiWrapper({
//     apiKey: ('AIzaSyA_d3pS7JqjFnGWc9hHkvT2MUQvAKo5Bio')
// })(Dashboard)